import React, { useEffect } from 'react';
import { Router } from '@uhg-abyss/web/ui/Router';
import { App } from '@src/app';
import { RouteWrapper } from '@src/common/RouteWrapper';
import { ProtectedRoute } from '@src/common/ProtectedRoute';
import { Welcome } from './Welcome';
import { NewGettingStarted } from './NewGettingStarted';
import { NewLanding } from './NewLanding';
import { SiteMap } from '@src/routes/SiteMap';
import { CreateCommunication } from './Welcome/CreateCommunication';
import { AllCommunications } from './Welcome/AllCommunications';
import { ReleaseNotes } from './Welcome/ReleaseNotes';
import { Intake } from './Welcome/Intake/Intake';
import { KnowledgeBase } from './KnowledgeBase';
import { AllAPIs } from './AllAPIs';
import { APIOverview } from './AllAPIs/APIOverview/APIOverview';
import { ApiFeedback } from './Welcome/OrganizationApi/OrganizationList/ApiFeedback';
import { CredentialsV2 } from './Welcome/CredentialsV2/CredentialsV2';
import { DocumentationHandler } from './DocumentationHandler';
import { useSelector } from 'react-redux';

export const Routes = () => {
  const userInfo = useSelector((state: any) => {
    return state.GET_USER_INFO.data;
  });

  useEffect(() => {
    if (userInfo?.uuid) {
      if (window?.dtrum) {
        (window?.dtrum as any)?.identifyUser(userInfo?.uuid);
      }
    }
  }, [userInfo]);

  return (
    <Router.Routes title="{{title}} | API Marketplace">
      <Router.Route path="/" element={<App />}>
        <Router.Route
          path="/"
          element={<RouteWrapper Component={NewLanding} routeName="Home" />}
        />
        <Router.Route
          path="/getting-started"
          element={
            <RouteWrapper
              Component={NewGettingStarted}
              routeName="Getting Started"
            />
          }
        />
        <Router.Route
          path="/knowledge-base/:resource"
          element={
            <RouteWrapper
              Component={KnowledgeBase}
              routeName="knowledge base resource"
            />
          }
        />
        {/* <Router.Route
          path="/documentation/superconnector/:slug?"
          element={
            <RouteWrapper
              Component={DocumentationV3}
              routeName="Technical documentation"
            />
          }
        /> */}
        <Router.Route
          path="/documentation/:service/:slug?"
          element={
            <RouteWrapper
              Component={DocumentationHandler}
              routeName="Technical documentation"
            />
          }
        />

        <Router.Route
          path="/knowledge-base"
          element={
            <RouteWrapper
              Component={KnowledgeBase}
              routeName="knowledge base"
            />
          }
        />

        <Router.Route
          path="/site-map"
          element={<RouteWrapper Component={SiteMap} routeName="Site Map" />}
        />
        <Router.Route
          path="/welcome/:service?-feedback"
          element={
            <ProtectedRoute Component={ApiFeedback} routeName="Feedback" />
          }
        />
        <Router.Route
          path="/welcome/create-communication"
          element={
            <ProtectedRoute
              Component={CreateCommunication}
              routeName="Create Communication"
            />
          }
        />
        <Router.Route
          path="/welcome/all-communications"
          element={
            <ProtectedRoute
              Component={AllCommunications}
              routeName="All Communications"
            />
          }
        />
        <Router.Route
          path="/welcome/credentials"
          element={
            <ProtectedRoute
              Component={CredentialsV2}
              routeName="CredentialsV2"
            />
          }
        />
        <Router.Route
          path="/welcome/release-notes/:resourceType"
          element={
            <ProtectedRoute
              Component={ReleaseNotes}
              routeName="Release Notes"
            />
          }
        />
        <Router.Route
          path="/welcome/release-notes"
          element={
            <ProtectedRoute
              Component={ReleaseNotes}
              routeName="Release Notes"
            />
          }
        />
        <Router.Route
          path="/welcome/release-notes"
          element={
            <ProtectedRoute
              Component={ReleaseNotes}
              routeName="Release Notes"
            />
          }
        />
        <Router.Route
          path="/welcome/intake"
          element={<ProtectedRoute Component={Intake} routeName="Intake" />}
        />
        <Router.Route
          path="/welcome"
          element={<ProtectedRoute Component={Welcome} routeName="Dashboard" />}
        />
        <Router.Route
          path="/all-apis"
          element={<RouteWrapper Component={AllAPIs} routeName="All APIs" />}
        />

        <Router.Route
          path="/all-apis/super-connector-api"
          element={
            <RouteWrapper Component={APIOverview} routeName="APIOverview" />
          }
        />
        <Router.Route
          path="/all-apis/super-connector-api/:apiName"
          element={
            <RouteWrapper
              Component={APIOverview}
              routeName="APIOverview"
              isSuperConnector={true}
            />
          }
        />
      </Router.Route>
    </Router.Routes>
  );
};
